import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { SelectionChangeType, PageType, EventHeaderTabType, LeagueTimeFilterType, ComponentName, EventMappingType, TimeFilter, SpecialOfferType } from 'src/app/models/enums';
import { SportsService } from 'src/app/services/sports.service';
import { ISportRegionCompetitionSelection } from 'src/app/models/sportHierarchy/sportRegionCompetitionSelection.interface';
import { ModelMapperService } from 'src/app/services/util/model.mapper.service';
import { Subscribable, Subscription } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { QueryParamsService } from 'src/app/services/http/queryParams.service';
import { IEventsGroupComponentViewModel } from 'src/app/models/event/eventsGroupComponentViewModel.interface';
import { UtilityService } from 'src/app/services/util/utility.service';
import { StorageService } from 'src/app/services/util/storage.service';
import { LocaleHelper } from 'src/locale/LocaleHelper';
import { CacheService } from 'src/app/services/cache.service';
import { ISport } from 'src/app/models/sportHierarchy/sport';
import { DynamicTranslations } from 'src/locale/dynamicTranslations';
import { CacheChangesService } from 'src/app/services/cacheChanges.service';
import { LoaderService } from 'src/app/services/loader.service';
import { ViewConfigurations } from 'src/app/models/util/viewConfigurations';

@Component({
  selector: 'app-events-header',
  templateUrl: './events-header.component.html',
  styleUrls: ['./events-header.component.less']
})
export class EventsHeaderComponent implements OnInit, OnDestroy {
  pageTypeEnum = PageType;
  public srcSelection: ISportRegionCompetitionSelection;
  public tabsType: EventHeaderTabType;
  public tabs: any[] = [];
  public title: string;
  public subtitle: string;
  public eventsNumber: number;
  leagueTimeFilter = LeagueTimeFilterType.League;
  public showNoEventsMessage = false;
  public eventHeaderTabTypeEnum = EventHeaderTabType;
  public specialOfferTypeEnum = SpecialOfferType;

  private subscription: Subscription = new Subscription();
  leagueTimeFilterTypeEnum = LeagueTimeFilterType;
  private isLive;
  private pageTypeChanged = false;

  viewConfigurations = ViewConfigurations;

  private language: string;
  private languageCulture: string;
  private dateToStringFormat: Intl.DateTimeFormatOptions = { weekday: 'long', year: 'numeric', month: '2-digit', day: '2-digit' };

  @Input()
  pageType: PageType;

  @Input()
  eventsGroupVM: IEventsGroupComponentViewModel;

  @Input()
  selectionChanged: boolean;

  showSortingForLive = false;

  public isMobileView: boolean;

  constructor(
    private sportsService: SportsService,
    private queryParamService: QueryParamsService,
    private utilityService: UtilityService,
    private storageService: StorageService,
    private cacheService: CacheService,
    private cacheChangesService: CacheChangesService,
    private loaderService: LoaderService) {
    this.pageType = queryParamService.pageType;
    this.subscription.add(this.queryParamService.pageTypeChanged$.subscribe((pt) => {
      if (this.pageType !== pt) {
        this.pageTypeChanged = true;
      }
      this.pageType = pt;
      if ((this.pageType === PageType.Soon && !ViewConfigurations.useSoonViewWhenTimeFilterIsChanged) || this.pageType === PageType.MostPopular) {
        this.getMostPopularOrSoonSports();
      }
    }));
    this.isMobileView = utilityService.mobileView;
    // add sports list loaded for other pages
    this.subscription.add(sportsService.srcSelectionChanged$.subscribe((x) => {
      if (x.callFrom === ComponentName.EventsHeaderComponent || x.callFrom === ComponentName.ResultEventsHeaderComponent || x.callFrom === ComponentName.ResultsSportTreeComponent || x.callFrom === ComponentName.ResultsSportsSelectionContainerComponent) {
        return;
      }
      this.srcSelection  = this.sportsService.sportRegionCompetitionSelection;
      // this.srcSelection = {
      //   sport: this.sportsService.sportRegionCompetitionSelection.sport,
      //   region: this.sportsService.sportRegionCompetitionSelection.region,
      //   competition: this.sportsService.sportRegionCompetitionSelection.competition,
      // };

      this.setSelectables(x.selectionChangeType);
    }));

    // this.subscription.add(this.cacheService.sportTreeChanged$.subscribe(() => this.updateHeader()));
    this.subscription.add(this.cacheService.sportTreeElementsWithAddedRemovedEventsChanged$.subscribe(srcSelectionIds => {
      if (this.pageType === PageType.Soon || this.pageType === PageType.MostPopular) {
        if (ViewConfigurations.useSoonViewWhenTimeFilterIsChanged) {
          this.setSelectables(SelectionChangeType.Sport, this.sportsService.getPMSportsTreeForSportTypeFilter([null]), !this.pageTypeChanged);
        }
        return;
      }
      if (this.srcSelection) {
        if (this.tabsType === EventHeaderTabType.Sport) {
          if (this.srcSelection.sport) {
            this.eventsNumber = this.srcSelection.sport.eventsCount;
          }
        } else if (this.tabsType === EventHeaderTabType.Region) {
          if (this.srcSelection.sport) {
            this.eventsNumber = this.srcSelection.sport.eventsCount;
          }
        } else {
          if (this.srcSelection.region) {
            this.eventsNumber = this.srcSelection.region.eventsCount;
          }
        }
      }

      if (this.tabs.findIndex(t => t.isSelected && t.eventsCount < 1) > -1) {
        const tabToSelect = this.tabs.find(t => !t.isSelected && t.eventsCount > 0);
        if (tabToSelect) {
          this.selectTab(tabToSelect);
        }
      }
    }));
    this.subscription.add(this.cacheService.mostPopularOrSoonEventAddedRemoved$.subscribe(sportIds => {
      if (this.pageType === PageType.Soon || this.pageType === PageType.MostPopular) {
        if (ViewConfigurations.useSoonViewWhenTimeFilterIsChanged) {
          return;
        }
        for (const sportId of sportIds) {
          if (this.tabs.findIndex(t => t.id === sportId) > -1) {
            this.getMostPopularOrSoonSports(true);
            return;
          }
        }
      }
    }));

    if (ViewConfigurations.useSoonViewWhenTimeFilterIsChanged) {
      if (this.queryParamService.pageType === PageType.MostPopular) {
        this.getMostPopularOrSoonSports();
      }
      this.subscription.add(this.sportsService.sportsTreeLoaded$.subscribe(() => {
        if (this.pageType === PageType.Soon) {
          this.setSelectables(SelectionChangeType.Sport, this.sportsService.getPMSportsTreeForSportTypeFilter([null]), !this.pageTypeChanged);
        }
      }));
    }
  }

  ngOnInit(): void {
    if (this.utilityService.mobileView) {
      this.dateToStringFormat = { weekday: 'short', month: '2-digit', day: '2-digit' };
    }
    this.language = this.storageService.language;
    this.languageCulture = LocaleHelper.cultureName[this.language];
    // this.subtitle = 'England';
    // this.title = 'Premier league';
    // this.tabsType = EventHeaderTabType.Competition;
    // this.tabs = [
    //   { name: 'Premier league', isSelected: true },
    //   { name: 'Championship', isSelected: false },
    //   { name: 'League One', isSelected: false },
    //   { name: 'League Two', isSelected: false },
    //   { name: 'National League', isSelected: false },
    //   { name: 'EFL Trophy', isSelected: false }
    // ];
    // this.pageType = this.queryParamService.pageType;

    if (this.pageType === PageType.Live) {
      this.isLive = true;
    } else {
      this.isLive = false;
    }

    if (this.pageType === PageType.Soon || this.pageType === PageType.MostPopular) {
      if (this.viewConfigurations.useSoonViewWhenTimeFilterIsChanged) {
        return;
      }
      this.getMostPopularOrSoonSports();
    } else {
      if (this.isMobileView) {
        this.srcSelection = this.sportsService.sportRegionCompetitionSelection;
        // this.srcSelection = {
        //   sport: this.sportsService.sportRegionCompetitionSelection.sport,
        //   region: this.sportsService.sportRegionCompetitionSelection.region,
        //   competition: this.sportsService.sportRegionCompetitionSelection.competition,
        // };
        this.setSelectables(this.sportsService.sportRegionCompetitionSelection.competition ? SelectionChangeType.Competition : this.sportsService.sportRegionCompetitionSelection.region && !this.sportsService.sportRegionCompetitionSelection.sport.specialOfferType ? SelectionChangeType.Region : SelectionChangeType.Sport);
      }
    }

  }

  getMostPopularOrSoonSports(selectLastSelectedSport: boolean = false) {
    this.loaderService.showHideLoader(true);
    if (this.pageType === PageType.Soon) {
      this.sportsService.getSportsStartingSoon().subscribe(sports => {
        // this.cacheChangesService.addSportsSubscribtion(sports.map(s => s.id), this.isLive);
        this.setSelectables(SelectionChangeType.Sport, sports, selectLastSelectedSport);
        this.loaderService.showHideLoader(false);
      });
    } else {
      this.sportsService.getMostPopularSports().subscribe(sports => {
        // this.cacheChangesService.addSportsSubscribtion(sports.map(s => s.id), this.isLive);
        this.setSelectables(SelectionChangeType.Sport, sports, selectLastSelectedSport);
        this.loaderService.showHideLoader(false);
      });
    }
  }

  backToTree() {
    this.queryParamService.pageType = PageType.Prematch;
  }

  filterByLeagueTime(leagueTimeFilter: LeagueTimeFilterType) {
    this.leagueTimeFilter = leagueTimeFilter;
    this.toggleLiveSorting();
  }

  private setSelectables(selctionsChangeType: SelectionChangeType, sports?: ISport[], selectLastSelectedTab: boolean = false) {
    this.showNoEventsMessage = false;
    switch (selctionsChangeType) {
      case SelectionChangeType.Sport:
        {
          this.showNoEventsMessage = false;
          if (this.pageType === PageType.Soon || this.pageType === PageType.MostPopular) {
            const selectedTab = this.tabs.find(t => t.isSelected);

            this.tabsType = EventHeaderTabType.Sport;
            this.tabs = sports;
            this.title = '';
            this.subtitle = this.pageType === PageType.Soon ? DynamicTranslations.otherTranslations_EventsHeader_StartingSoon : DynamicTranslations.otherTranslations_EventsHeader_MostPlayed;

            if (ViewConfigurations.useSoonViewWhenTimeFilterIsChanged && this.pageType === PageType.Soon) {
              if (this.sportsService.timeFilterValueGet !== TimeFilter.Today) {
                if (this.sportsService.timeFilterValueGet !== TimeFilter.All) {
                  this.subtitle = this.utilityService.getDateFromTo(this.isLive, this.sportsService.timeFilterValueGet).dateFrom.toLocaleDateString(this.languageCulture, { weekday: 'long', year: 'numeric', month: '2-digit', day: '2-digit' });

                } else {
                  this.subtitle = DynamicTranslations.otherTranaslations_FilterNavigationTitle_All;
                }
              }
            }

            if (selectLastSelectedTab) {
              if (selectedTab) {
                const newTabToSelect = this.tabs.find(t => t.id === selectedTab.id);
                if (newTabToSelect && newTabToSelect.eventsCount > 0) {
                  this.selectTab(newTabToSelect);
                  return;
                }
              }
            }

            if (this.viewConfigurations.useSoonViewWhenTimeFilterIsChanged && this.pageType === PageType.Soon) {
              const newTabToSelect = this.tabs.find(t => t.eventsCount > 0);
              if (newTabToSelect) {
                this.selectTab(newTabToSelect);
                return;
              }
              else{
                  this.showNoEventsMessage = true;
                  this.sportsService.selectSportNotify(null, this.isLive, ComponentName.EventsHeaderComponent);
                  return;
              }
            }

            if (this.tabs[0]) {
            //  this.tabs[0].isSelected = false;
              this.selectTab(this.tabs[0]);
            }

            if (!sports || sports.length < 1) {
              this.showNoEventsMessage = true;
            }
          } else {
            const sport = this.srcSelection.sport;
            if (!sport) {
              this.showNoEventsMessage = true;
              return;
            }
            this.tabsType = EventHeaderTabType.Region;
            this.tabs = sport.regions;
            this.title = sport.name;
            this.subtitle = '';
            this.eventsNumber = sport.eventsCount;
            // const selectedTab = this.tabs.findIndex(t => t.isSelected);
          }

        }
        break;
      // case SelectionChangeType.Competition:
      case SelectionChangeType.Region:
        {
          if (this.pageType !== PageType.Live) {
            const region = this.srcSelection.region;
            if (!region) {
              this.showNoEventsMessage = true;
              return;
            }

            this.title = region.name;

            this.eventsNumber = region.eventsCount;
            this.subtitle = this.srcSelection.sport.name;
            // if (this.srcSelection.competition) {
            //   this.title = this.srcSelection.competition.name;
            // }
            this.tabs = region.competitions;
            if (ViewConfigurations.showAllEventsButtonOnSelectedRegion) {
              this.tabsType = EventHeaderTabType.RegionAndCompetitions;
              this.tabs = [region, ...this.tabs];
            }
          }
        }
        break;
      case SelectionChangeType.Competition:
        {
          if (this.srcSelection.competition) {
            this.tabsType = EventHeaderTabType.Competition;
            this.tabs = this.srcSelection.region.competitions;
            this.title = this.srcSelection.region.name;
            this.eventsNumber = this.srcSelection.region.eventsCount;
            this.subtitle = this.srcSelection.sport.name;
            if (ViewConfigurations.showAllEventsButtonOnSelectedRegion) {
              this.tabsType = EventHeaderTabType.RegionAndCompetitions;
              this.tabs = [this.srcSelection.region, ...this.tabs];
            }
          }
        }
        break;
    }

    // const selectedTab = this.tabs.find(tab => tab.isSelected);
    // if (selectedTab) {
    //   this.selectTab(selectedTab, true);
    // }
    this.pageTypeChanged = false;
  }

  toggleLiveSorting() {
    this.showSortingForLive = !this.showSortingForLive;
  }

  selectTab(tab: any, justNotify: boolean = false) {
    if (tab.isSelected && !justNotify) {
      return;
    }

    if (!justNotify) {
      for (const t of this.tabs) {
        t.isSelected = false;
      }

      tab.isSelected = true;
    }

    switch (this.tabsType) {
      case EventHeaderTabType.Competition:
        this.sportsService.selectCompetitionNotify(tab, this.srcSelection.region, this.srcSelection.sport, this.isLive, ComponentName.EventsHeaderComponent);
        break;
      case EventHeaderTabType.RegionAndCompetitions:
        if (tab.competitions) {
          // added for cro because in same type we also have region and competitions
          this.sportsService.selectRegionNotify(tab, this.srcSelection.sport, this.isLive, ComponentName.EventsHeaderComponent);
        } else {
          this.sportsService.selectCompetitionNotify(tab, this.srcSelection.region, this.srcSelection.sport, this.isLive, ComponentName.EventsHeaderComponent);
        }
        break;
      case EventHeaderTabType.Region:
        this.sportsService.selectRegionNotify(tab, this.srcSelection.sport, this.isLive, ComponentName.EventsHeaderComponent);
        break;
      case EventHeaderTabType.Sport:
        if (this.pageType === PageType.Soon || this.pageType === PageType.MostPopular) {
          this.sportsService.selectMostPopularOrEventsSoonSport(tab, tab.eventsCount);
          this.utilityService.changeParentSrcUrl(tab.id, tab.name);
        } else {
          this.sportsService.selectSportNotify(tab, this.isLive, ComponentName.EventsHeaderComponent);
        }
        break;
    }
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
